<template>
    <div class="office-expenses office-expenses__container container-fluid">
        <div class="card">
            <div class="card-body">
                <form
                    class="row office-expenses__search"
                    action=""
                    @submit.prevent="searchExpenses"
                >
                    <div class="col-md-3 col-sm-12">
                        <label>Search</label>
                        <input
                            type="search"
                            class="form-control"
                            placeholder="Search expense..."
                            v-model="params.search"
                        >
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>Employee</label>
                        <user-select
                            v-if="users.length"
                            v-model="params.employee_id"
                            :options="users"
                            :office="false"
                            :admins="false"
                            :autoselect="false"
                        />
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>From Date</label>
                        <date-picker v-model="params.from_date" />
                    </div>
                    <div class="col-md-2 col-sm-12">
                        <label>To Date</label>
                        <date-picker v-model="params.to_date" />
                    </div>
                    <div class="col-md-3 col-sm-12 text-right">
                        <br>
                        <button
                            class="btn btn-primary"
                            v-if="!loading"
                        >
                            Search
                        </button>
                        <button
                            class="btn btn-primary"
                            v-if="loading"
                            disabled
                        >
                            Loading...
                        </button>
                        <button
                            class="btn btn-default"
                            @click.prevent="resetSearch"
                        >
                            Reset
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <table
                    class="table"
                    v-if="loaded && users"
                >
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Reviewed By</th>
                            <th class="text-right">
                                <select
                                    v-model="params.per_page"
                                    @input="searchExpenses"
                                    class="form-control text-right"
                                    style="width: 10rem; display: inline-block;"
                                >
                                    <option value="25">
                                        25 per page
                                    </option>
                                    <option value="50">
                                        50 per page
                                    </option>
                                    <option value="100">
                                        100 per page
                                    </option>
                                </select>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <expense-row
                            v-for="(expense, index) in expenses"
                            :key="expense.id"
                            :expense="expense"
                            :users="users"
                            @deleted="deleteExpense(index)"
                            @review="showReviewModal(expense)"
                        />
                        <tr v-if="!loading && !expenses.length">
                            <td colspan="4">
                                No matching expenses, try changing your filter or <a
                                    href="#"
                                    @click.prevent="resetSearch"
                                >reset your search</a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <pagination
                    :page="params.page"
                    :last-page="lastPage"
                    v-if="loaded"
                    @pageChange="pageChange"
                />
            </div>
        </div>
        <review-modal
            v-if="inReview"
            :expense="inReview"
            @close="inReview = null"
        />
    </div>
</template>

<script>
import UserSelect from '../../UserSelectComponent';
import DatePicker from '../../DateTimePickerComponent';
import ExpenseRow from './RowComponent';
import Pagination from '../../PaginationComponent';
import UsersService from '../../../services/UsersService';
import AuthService from '../../../services/AuthService';
import Service from '../../../services/EmployeeExpensesService';
import ReviewModal from './ReviewModal.vue';

export default {
    components: {
        UserSelect,
        DatePicker,
        ExpenseRow,
        Pagination,
        ReviewModal,
    },
    data () {
        return {
            loading: false,
            loaded: false,
            params: {
                search: '',
                page: 1,
                user_id: null,
                per_page: 25,
                from_date: window.moment().startOf('month'),
            },
            expenses: [],
            total: 0,
            lastPage: 1,
            users: [],
            inReview: null,
        };
    },
    computed : {
        canAddRow () {
            return AuthService.user.admin_access;
        },
    },
    mounted () {
        this.loadExpenses();
        this.listenToEvents();
        UsersService.engineers().then(res => {
            this.users = res.data;
        })
    },
    beforeDestroy () {
        window.Echo.leave('employee-expenses');
    },
    methods: {
        searchExpenses () {
            this.params.page = 1;
            this.loadExpenses();
        },
        loadExpenses () {
            this.loading = true;
            const params = {...this.params};
            params.from_date = params.from_date ? params.from_date.format('YYYY-MM-DD HH:mm') : null;
            params.to_date = params.to_date ? params.to_date.format('YYYY-MM-DD HH:mm') : null;
            Service.index(params).then(res => {
                this.expenses = res.data.data;
                this.total = res.data.total;
                this.lastPage = res.data.last_page;
                this.loading = false;
                this.loaded = true;
            })
        },
        pageChange (page) {
            this.params.page = page;
            this.loadExpenses();
        },
        resetSearch () {
            this.params = {
                search: '',
                page: 1,
                user_id: null,
                from_date: window.moment().startOf('month'),
                to_date: null,
                per_page: 25,

            }
            this.loadExpenses();
        },
        listenToEvents () {
            const channel = window.Echo.channel('employee-expenses')
            channel.listen('EmployeeExpenseChanged', event => {
                var i = this.expenses.findIndex(expense => expense.id === event.employeeExpense.id);
                if (i >= 0) {
                    this.expenses[i] = event.employeeExpense;
                    this.$forceUpdate();
                }
            });
        },
        addRow () {
            this.expenses.unshift({
            });
        },
        deleteExpense (index) {
            this.expenses.splice(index, 1);
        },
        showReviewModal (expense) {
            this.inReview = expense;
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/expenses/IndexComponent.vue